import {
    interval,
    Observable,
    ObservableLike,
    PartialObserver,
    Subject,
    Subscribable,
    Unsubscribable
    } from "rxjs";
import { sample } from "rxjs/operators";

export interface ILogin
{
    token?: string;
    username?: string;
}

class AuthenticatorImpl implements Subscribable<ILogin | undefined>
{
    private _subject = new Subject<ILogin | undefined>();
    private _login?: ILogin;

    get token(): string | undefined { return this._login ? this._login.token : undefined; }
    get username(): string | undefined { return this._login ? this._login.username : undefined; }
    get isLoggedIn(): boolean { return !!this._login; }

    public update(login?: ILogin)
    {
        this._login = login;
        this._subject.next(login);
    }

    public subscribe(observerOrNext?: PartialObserver<ILogin> | ((value: ILogin | undefined) => void), error?: (error: any) => void, complete?: () => void): Unsubscribable
    {
        return this._subject
            .pipe(sample(interval(100)))
            .subscribe(...arguments);
    }
}

// tslint:disable-next-line:variable-name
export let Authenticator = new AuthenticatorImpl();
